import { shade } from "polished";
import styled, { css } from "styled-components";

import { size } from "~/styles/screen";

type Inverted = { inverted?: boolean };

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  position: relative;
`;

export const Viewport = styled.div`
  padding-bottom: calc(0.35rem * 14);
`;

export const Brand = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin-top: 1.875rem;
  margin-left: 3.75rem;

  @media screen and (max-width: ${size.small}) {
    margin-left: 2rem;
  }
`;

export const LogoContainer = styled.div<Inverted>`
  background-color: transparent;
  width: ${1100 * 0.1}px;
  height: ${235 * 0.1}px;
  ${(props) =>
    props.inverted &&
    css`
      filter: brightness(0) invert(1);
    `}
`;

export const LogoText = styled.text`
  font-family: "Montserrat";
  font-weight: 700;
  color: white;
  font-size: 12px;
  line-height: 14.63px;
  margin-left: 15px;
  cursor: pointer;
  text-transform: uppercase;
`;

export const NavButtonsContainer = styled.div`
  display: flex;
  margin-top: 1.875rem;
  margin-right: 3.75rem;
  width: 15%;
  justify-content: space-around;
  align-items: flex-end;
`;

export const NavButtonText = styled.a`
  font-weight: 700;
  font-family: "Montserrat";
  font-size: 12px;
  line-height: 14.63px;
  color: white;
  text-transform: uppercase;
  text-decoration: none;

  &:hover {
    color: white;
  }
`;

export const ActionButton = styled.button`
  background: #72e85f;
  min-height: 30px;
  width: 196px;
  border: 1px solid #72e85f;
  box-sizing: border-box;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background-color 0.2s;
  align-self: center;
  justify-content: center;
  padding: 5px;
  &:hover {
    background: ${shade(0.1, "#72e85f")};
  }
`;

export const Title = styled.text`
  font-family: "Montserrat";
  color: black;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  line-height: 15.6px;
`;
